<template>
  <div class="relative p-2 w-full text-xs h-full bg-white">
    <form @submit.prevent="submitForm" class="h-full">
      <base-form class="h-full">
        <template #body>
          <div class="w-full h-full">
            <div class="grid grid-cols-4 gap-3 w-full">
              <!-- <div class=""> -->
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500">Client Name*</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="clientName"
                    v-model="client_name"
                    placeholder="Enter client name with no punctuation"
                    required
                  />
                </div>
                <div class="flex flex-col pb-2">
                  <label class="tracking-widest text-gray-500" for="researchComplete">Status</label>
                  <select
                    id="status"
                    v-model="status"
                    class="border p-1 border-gray-400 mt-1 rounded-md w-full"
                  >
                    <option value="active">Active</option>
                    <option value="prospect">Prospect</option>
                    <option value="finders fee">Finders Fee</option>
                    <option value="tail">Tail</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="legalBusinessName">Legal Business Name</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="legalBusinessName"
                    v-model="legal_business_name"
                    placeholder="Legal Business Name"
                  />
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="emailAlias">Email Alias</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="emailAlias"
                    v-model="email_alias"
                    placeholder="Email Alias"
                  />
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="billingName">Billing Name</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="billingName"
                    v-model="billing_name"
                    placeholder="Billing Name"
                  />
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="owner">Owner</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="owner"
                    v-model="owner"
                    placeholder="Owner"
                  />
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="owner">Address</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="address"
                    v-model="address"
                    placeholder="Address"
                  />
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="owner">City</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="city"
                    v-model="city"
                    placeholder="City"
                  />
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="owner">State</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="state"
                    v-model="state"
                    placeholder="State"
                  />
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="owner">Zip</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="zip"
                    v-model="zip"
                    placeholder="Zip"
                  />
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="owner">Country</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="country"
                    v-model="country"
                    placeholder="Country"
                  />
                </div>
                <div class="flex flex-col pb-3">
                  <label class="tracking-widest text-gray-500" for="owner">Time Zone</label>
                  <select
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    id="timeZone"
                    v-model="time_zone"
                    placeholder="Time Zone"
                  >
                    <option :value="null">-------</option>
                    <!-- <option value="UTC-12:00 (AoE) - Baker Island and Howland Island">UTC-12:00 (AoE) - Baker Island and Howland Island</option>
                    <option value="UTC-11:00 (ST) - American Samoa, Jarvis Island, Kingman Reef, Midway Atoll and Palmyra Atoll">UTC-11:00 (ST) - American Samoa, Jarvis Island, Kingman Reef, Midway Atoll and Palmyra Atoll</option>
                    <option value="UTC-10:00 (HT) - Hawaii, most of the Aleutian Islands, and Johnston Atoll">UTC-10:00 (HT) - Hawaii, most of the Aleutian Islands, and Johnston Atoll</option> -->
                    <option value="UTC-09:00 (AKT) - Most of the state of Alaska">UTC-09:00 (AKT) - Most of the state of Alaska</option>
                    <option value="UTC-08:00 (PT) - Pacific Time zone">UTC-08:00 (PT) - Pacific Time zone</option>
                    <option value="UTC-07:00 (MT) - Mountain Time zone">UTC-07:00 (MT) - Mountain Time zone</option>
                    <option value="UTC-06:00 (CT) - Central Time zone">UTC-06:00 (CT) - Central Time zone</option>
                    <option value="UTC-05:00 (ET) - Eastern Time zone">UTC-05:00 (ET) - Eastern Time zone</option>
                    <!-- <option value="UTC-04:00 (AST) - Puerto Rico, the U.S. Virgin Islands">UTC-04:00 (AST) - Puerto Rico, the U.S. Virgin Islands</option>
                    <option value="UTC+10:00 (ChT) - Guam and the Northern Mariana Islands">UTC+10:00 (ChT) - Guam and the Northern Mariana Islands</option>
                    <option value="UTC+12:00 (WAKT) - Wake Island">UTC+12:00 (WAKT) - Wake Island</option> -->
                </select>
                </div>
                <!-- <div class="flex flex-col pb-2">
                  <label class="tracking-widest text-gray-500" for="acquisitionDate">Engagement Start</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="date"
                    id="engagementStart"
                    v-model="engagement_start"
                  />
                </div> -->
                <div class="flex flex-col pb-2">
                  <label class="tracking-widest text-gray-500" for="city">Dropbox URL</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="url"
                    id="pdfLink"
                    v-model="dropbox_url"
                  />
                </div>
              <!-- </div> -->
              <!-- <div> -->
                <div class="flex flex-col pb-2">
                  <label class="tracking-widest text-gray-500" for="researchComplete">Tail End Date</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="date"
                    id="tailEndDate"
                    v-model="tail_end_date"
                  />
                </div>
                <!-- <div class="flex flex-col pb-2">
                  <label class="tracking-widest text-gray-500" for="acquisitionDate">Engagement End</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="date"
                    id="engagementEnd"
                    v-model="engagement_end"
                  />
                </div> -->
                <div class="flex flex-col pb-2">
                  <label class="tracking-widest text-gray-500" for="address">Retainer Amount</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="number"
                    id="retainerAmount"
                    placeholder=" e.g. 10000"
                    v-model="retainer_amount"
                  />
                </div>
              <!-- </div> -->
              <!-- <div> -->
                <div class="flex flex-col pb-2">
                  <label class="tracking-widest text-gray-500" for="researchComplete">Account Manager</label>
                  <select
                    id="accountManagerID"
                    v-model="account_manager_id"
                    class="border p-1 border-gray-400 mt-1 rounded-md w-full"
                  >
                    <option :value="null">------------</option>
                    <option
                      v-for="option in accountManagerOptions"
                      :key="option.id"
                      :value="option.id"
                    >
                      {{ option.first_name }} {{ option.last_name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col pb-2">
                  <label class="tracking-widest text-gray-500" for="state">Fee Structure</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="feeStructure"
                    v-model="fee_structure"
                  />
                </div>
                <!-- <div class="flex flex-col pb-2">
                  <label class="tracking-widest text-gray-500" for="address">Retainer Frequency</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    id="retainerFrequency"
                    v-model="retainer_frequency"
                  />
                </div> -->
                <div class="flex flex-col col-span-4 pb-2">
                  <label class="tracking-widest text-gray-500" for="address">Accounts Payable Emails</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="email"
                    multiple
                    id="accountsPayableEmails"
                    v-model="accounts_payable_emails"
                    placeholder="emails separated by commas"
                  />
                </div>
                <div class="flex flex-col col-span-4 pb-2">
                  <label class="tracking-widest text-gray-500" for="address">Accounts Payable CCs</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="email"
                    multiple
                    id="accountsPayableCCs"
                    v-model="accounts_payable_ccs"
                    placeholder="emails separated by commas"
                  />
                </div>
                <div class="flex flex-col col-span-4 pb-2">
                  <label class="tracking-widest text-gray-500" for="address">Client Websites</label>
                  <input
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    type="text"
                    multiple
                    id="clientWebsites"
                    v-model="website_urls"
                    placeholder="webistes separated by commas"
                  />
                </div>
              <!-- </div> -->
            </div>
            <div class="grid grid-cols-3 gap-3 w-full">
              <div>
                <div class="flex flex-col col-span-2 pb-2">
                  <label class="tracking-widest text-gray-500" for="mergeConflicts">Contact Notes</label>
                  <textarea
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    rows="5"
                    id="contactNotes"
                    v-model="contact_notes"
                  ></textarea>
                </div>
                <div class="flex flex-col col-span-2 pb-2">
                  <label class="tracking-widest text-gray-500" for="mergeConflicts">Scope of Buying</label>
                  <textarea
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    rows="5"
                    id="scopeOfBuying"
                    v-model="scope_of_buying"
                  ></textarea>
                </div>
              </div>
              <div>
                <div class="flex flex-col col-span-2 pb-2">
                  <label class="tracking-widest text-gray-500" for="mergeConflicts">Duration of Retainer</label>
                  <textarea
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    rows="5"
                    id="durationOfRetainer"
                    v-model="duration_of_retainer"
                  ></textarea>
                </div>
                <div class="flex flex-col col-span-2 pb-2">
                  <label class="tracking-widest text-gray-500" for="mergeConflicts">Engagement Notes</label>
                  <textarea
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    rows="5"
                    id="engagementNotes"
                    v-model="engagement_notes"
                  ></textarea>
                </div>
              </div>
              <div>
                <div class="flex flex-col col-span-2 pb-2">
                  <label class="tracking-widest text-gray-500" for="mergeConflicts">Source History</label>
                  <textarea
                    class="p-1 border mt-1 border-gray-400 rounded-md"
                    rows="5"
                    id="sourceHistory"
                    v-model="source_history"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-1 w-full my-2">
              <div class="col-span-2 w-full border-b">
                Account Staff Members
              </div>
              <div class="flex w-full justify-center">
                <div class="flex flex-col border w-5/6">
                  <div class="w-full bg-gray-200 p-2 flex items-center justify-center">
                    Available Users
                  </div>
                  <div class="flex flex-col p-2 h-44 overflow-auto">
                    <div v-for="user in availableStaffMembers" :key="user.id" :draggable="true" :ondragstart="dragStartHandler" :ondragend="dragEndHandler" :id="user.id" class="m-1 p-1 border rounded-md hover:cursor-grab">
                        {{ user.first_name }} {{ user.last_name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex w-full justify-center">
                <div class="flex flex-col border w-5/6">
                  <div class="w-full bg-gray-200 p-2 flex items-center justify-center">
                    Assigned Members
                  </div>
                  <div class="flex flex-col p-2 h-44 overflow-auto w-full" :ondragover="dragOverHandler" :ondrop="dropHandler">
                    <div v-for="user in account_staff_members" :key="user.id" class="m-1 p-1 border rounded-md flex items-center justify-between">
                      <div>
                        {{ user.first_name }} {{ user.last_name }}
                      </div>
                      <div>
                        <base-button-negative @click.prevent="removeAccountStaff(user.id)">
                          <XMarkSVG strokeColor="white" />
                        </base-button-negative>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="client" class="grid grid-cols-3 w-full">
              <div ref="configurationInfo" class="col-span-3 w-full border-b">
                  Invoice Reminder Configuration
                  <div  @mouseover="showPopover" @mouseleave="hidePopover" class="border inline border-black h-fit bg-white bg-opacity-40 text-black px-1 rounded-lg text-xs hover:cursor-default">?</div>
              </div>
              <base-popover-hover-small
                  class="w-fit"
                  v-if="isPopoverVisible"
                  :xPosition="xPosition"
                  :yPosition="yPosition"
              >
                  <template #title>
                    <span class="text-sm">Configuration Info:</span>
                  </template>
                  <template #body>
                      <div class="py-1 border-gray-300 w-full">
                          These numbers indicate the days from an invoice's due date on which you will be prompted to send a reminder to the client. Negative values indicate days before the invoice due date; positive values, days after the invoice due date. For example: -2 is two days before the invoice is due, 2 is two days after the invoice is due.
                      </div>
                  </template>
              </base-popover-hover-small>
            </div>
            <div v-if="client" class="grid grid-cols-3 gap-3 w-full p-1">
              <div class="flex space-x-2 pb-3 col-span-3">
                  <label class="flex items-center" for="daysFromInvoiceDueDate">Days from Invoice Due Date:</label>
                  <input
                    class="border p-1 border-dark-primary rounded-md w-fit"
                    type="number"
                    id="daysFromInvoiceDueDate"
                    v-model="daysFromInvoiceDueDate"
                  />
                  <base-button-affirmative @click.prevent="addInvoiceConfig">
                    Add
                  </base-button-affirmative>
                  <div v-if="invoiceReminderConfigurations" class="flex space-x-2">
                    <base-pill-x @click="removeInvoiceReminderConfig(config.id)" class="flex items-center justify-between space-x-2 px-2 h-fit hover:cursor-pointer" v-for="config in invoiceReminderConfigurations" :key="config.id">
                      <div>{{ config.days_from_invoice_due_date }}</div>
                      <!-- <div>✗</div> -->
                    </base-pill-x>
                  </div>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <div class="flex items-center w-full justify-center my-2">
            <base-button-affirmative type="submit"
              >Save and Close</base-button-affirmative
            >

              <button
              class="
          rounded-md
          px-1
          py-1
          border
          border-black
          hover:shadow-md
          active:text-white
          active:bg-accent-secondary
          focus:text-white
          focus:bg-accent-secondary
          text-xs
          cursor-pointer
          mx-1
          sm:text-xs
          sm:h-fit
        "
                  @click.prevent="submitForm(false)">Save
              </button>
          </div>
        </template>
      </base-form>
    </form>
  </div>
</template>

<script setup>
// imports

import { ref, defineEmits, defineProps, onMounted, computed } from "vue";
import { getUsersByGroup } from "../../services/User.js";
import { useStore } from "vuex";
import { addInvoiceReminderConfiguration } from "@/services/Client.js"
import { createClient } from "@/services/Client.js";
import { deleteClientInvoiceReminderConfiguration } from "@/services/ClientInvoiceReminderConfiguration.js"
import { useToast } from 'vue-toast-notification';
import XMarkSVG from "../svg-components/XMarkSVG.vue";
import ClientCloseButton from "./UI/ClientCloseButton.vue";

// constants/variables

const store = useStore();
const $toast = useToast()

const props = defineProps(["client", "index", "account_id", "addOrEdit"]);
const emit = defineEmits(["submit-edit-form","close-edit-form", "submit-add-form", "close-add-form", "refetch-clients", 'close']);

const client_name = ref(props.client ? props.client.client_name: null);
const id = ref(props.client ? props.client.id: null);
const status = ref(props.client ? props.client.status: null);
const account_manager_id = ref(
  computeAccountManagerID(props.client ? props.client.active_account_manager: null)
);
// const engagement_start = ref(props.client ? props.client.engagement_start: null);
// const engagement_end = ref(props.client ? props.client.engagement_end: null);
const fee_structure = ref(props.client ? props.client.fee_structure: null);
// const retainer_frequency = ref(props.client ? props.client.retainer_frequency: null);
const accounts_payable_emails = ref(props.client ? props.client.accounts_payable_emails: null);
const accounts_payable_ccs = ref(props.client ? props.client.accounts_payable_ccs: null);
const website_urls = ref(props.client ? props.client.website_urls: null);
const dropbox_url = ref(props.client ? props.client.dropbox_url: null);
const contact_notes = ref(props.client ? props.client.contact_notes: null);
const retainer_amount = ref(props.client ? props.client.retainer_amount: null);
const scope_of_buying = ref(props.client ? props.client.scope_of_buying: null);
const duration_of_retainer = ref(props.client ? props.client.duration_of_retainer: null);
const engagement_notes = ref(props.client ? props.client.engagement_notes: null);
const source_history = ref(props.client ? props.client.source_history: null);
const legal_business_name = ref(props.client ? props.client.legal_business_name: null);
const email_alias = ref(props.client ? props.client.email_alias: null);
const billing_name = ref(props.client ? props.client.billing_name: null);
const owner = ref(props.client ? props.client.owner: null);
const address = ref(props.client ? props.client.address: null);
const city = ref(props.client ? props.client.city: null);
const state = ref(props.client ? props.client.state: null);
const country = ref(props.client ? props.client.country: null);
const zip = ref(props.client ? props.client.zip: null);
const time_zone = ref(props.client ? props.client.time_zone: null);
const tail_end_date = ref(props.client ? props.client.tail_end_date: null);
const account_staff_members = ref(props.client ? props.client.account_staff_members: []);
const daysFromInvoiceDueDate = ref(0)

const accountManagerOptions = ref([]);
const isPopoverVisible = ref(false)
const configurationInfo = ref(null)
const xPosition = ref(0)
const yPosition = ref(0)

function showPopover() {
    isPopoverVisible.value = true;
    xPosition.value = configurationInfo.value.getBoundingClientRect().left
    yPosition.value = configurationInfo.value.getBoundingClientRect().bottom
}

function hidePopover() {
    isPopoverVisible.value = false;
    xPosition.value = 0;
    yPosition.value = 0;
}
// async functions

async function setAccountManagerOptions() {
  let payload = {
    token: store.state.auth.token,
    endpoint: "users",
    group: "account_manager_group&group=management_group&group=account_staff_group",
  };
  const result = await getUsersByGroup(payload);
  accountManagerOptions.value = result.users.filter((accountManager) => ![2, 10, 16, 22].includes(accountManager.id))
}

const invoiceReminderConfigurations = computed(() => {
  if(props.client && props.client.invoice_reminder_configurations.length > 0){
    return props.client.invoice_reminder_configurations
  } else {
    return null
  }
})

async function addInvoiceConfig(){
  const token = store.state.auth.token
  const data = {
    days_from_invoice_due_date: daysFromInvoiceDueDate.value
  }
  const payload = {
    data: data,
    token: token,
    id: props.client.id
  }
  // console.log('payload', payload)
  const result = await addInvoiceReminderConfiguration(payload)
  if(result.status == 201){
    $toast.open({
      message: `Successfully added configuration for ${props.client.client_name}`,
      type: "success",
      duration: 3000
    })
    daysFromInvoiceDueDate.value = 0
    emit('refetch-clients')
  } else if (result.status == 400){
    $toast.open({
      message: `Configuration for ${props.client.client_name} with ${daysFromInvoiceDueDate.value} days already exists`,
      type: "error",
      duration: 3000
    })
  } else {
    $toast.open({
      message: `Could not create configuration for ${props.client.client_name}`,
      type: "error",
      duration: 3000
    })
  }
}

async function removeInvoiceReminderConfig(configId){
  const token = store.state.auth.token
  const result = await deleteClientInvoiceReminderConfiguration(token, configId)
  if(result.status == 204){
    $toast.open({
      message: `Removed configuration for ${props.client.client_name}`,
      type: "success",
      duration: 3000
    })
    emit('refetch-clients')
  } else {
    $toast.open({
      message: `Could not remove configuration for ${props.client.client_name}`,
      type: "error",
      duration: 3000
    })
  }
}

// functions

function submitForm(closeAfterSave=true) {
  if(!Array.isArray(accounts_payable_emails.value) && accounts_payable_emails.value){
      accounts_payable_emails.value = accounts_payable_emails.value.split(",")
  }
  if(!Array.isArray(accounts_payable_ccs.value) && accounts_payable_ccs.value){
      accounts_payable_ccs.value = accounts_payable_ccs.value.split(",")
  }
  if(!Array.isArray(website_urls.value) && website_urls.value){
      website_urls.value = website_urls.value.split(",")
  }
  if(!website_urls.value){
    website_urls.value = []
  }
  if(!accounts_payable_ccs.value){
    accounts_payable_ccs.value = []
  }
  if(!accounts_payable_emails.value){
    accounts_payable_emails.value = []
  }
  const formData = {
    client_name: client_name.value,
    status: status.value,
    account_manager_id: account_manager_id.value,
    // engagement_start: engagement_start.value,
    // engagement_end: engagement_end.value,
    fee_structure: fee_structure.value,
    // retainer_frequency: retainer_frequency.value,
    dropbox_url: dropbox_url.value,
    contact_notes: contact_notes.value,
    retainer_amount: retainer_amount.value,
    scope_of_buying: scope_of_buying.value,
    duration_of_retainer: duration_of_retainer.value,
    engagement_notes: engagement_notes.value,
    source_history: source_history.value,
    legal_business_name: legal_business_name.value,
    email_alias: email_alias.value,
    billing_name: billing_name.value,
    owner: owner.value,
    accounts_payable_emails: accounts_payable_emails.value,
    accounts_payable_ccs: accounts_payable_ccs.value,
    website_urls: website_urls.value,
    address: address.value,
    city: city.value,
    state: state.value,
    zip: zip.value,
    country: country.value,
    time_zone: time_zone.value,
    tail_end_date: tail_end_date.value,
    account_staff_members: account_staff_members.value
  };
  if (props.addOrEdit === "add") {
    addNewClient(formData)
  } else {
    emit("submit-edit-form", id.value, formData, closeAfterSave);
  }
}

function closeForm() {
    if (props.addOrEdit === "add") {
        emit("close-add-form");
    } else {
        emit("close-edit-form")
    }
}

function computeAccountManagerID(manager) {
  if (manager && manager.user) {
    return manager.user.id;
  } else {
    return null;
  }
}


async function addNewClient(formData) {
  const token = store.state.auth.token;
  const result = await createClient(formData, token);
  if (result.status == 200) {
    $toast.open({
        message: 'Successfully created new client',
        type: 'success',
        duration: 3000
    })
    emit('refetch-clients')
    emit('close')
  } else {
    $toast.open({
        message: 'Error, could not create new client',
        type: 'error',
        duration: 3000
    })
  }
}

const isDragging = ref(false)
const draggingUser = ref(null)

function dragOverHandler(ev) {
  ev.preventDefault();
}

function dropHandler(ev) {
  ev.preventDefault();
  isDragging.value = false
  account_staff_members.value.push(draggingUser.value)
}

function dragStartHandler(ev) {
  isDragging.value = true
  ev.dataTransfer.effectAllowed = "copyMove";
  draggingUser.value = accountManagerOptions.value.find((user) => {
    return user.id == ev.target.id
  })
}

function dragEndHandler(ev) {
    ev.preventDefault()
    isDragging.value = false
    draggingUser.value = null
}

const availableStaffMembers = computed(() => {
  const accountStaffMemberIds = account_staff_members.value.map((user) => user.id)
  return accountManagerOptions.value.filter((user) => {
    return !accountStaffMemberIds.includes(user.id)
  })
})

function removeAccountStaff(userId){
  account_staff_members.value.splice(account_staff_members.value.findIndex((user) => user.id == userId), 1)
}

// life-cycle

onMounted(() => {
  setAccountManagerOptions();
});
</script>
